import { FC } from 'react';
import { OrderExpandedContainer } from 'src/trpc';

interface Props {
  orderContainer: OrderExpandedContainer;
}

export const ContainerDetails: FC<Props> = ({ orderContainer }) => {
  // Add null check for orderContainer
  if (!orderContainer) {
    return (
      <div className="card bg-gray-100 flex flex-col gap-4 justify-start items-start w-full">
        <p className="text-sm text-gray-500">Container details not available</p>
      </div>
    );
  }

  const { containers, truck, driver } = orderContainer;

  // TODO: Somehow truck.addons is being saved as a single string rather than an array.
  const truckAddOns = Array.isArray(truck?.addOns) ? truck?.addOns : [truck?.addOns];

  return (
    <div className="card bg-success-muted flex flex-col gap-4 justify-start items-start w-full">
      {driver && (
        <div>
          <p className="label text-xs">Assigned Driver</p>
          <p className="font-semibold underline text-sm">
            {driver.name?.first || 'Unknown'} {driver.name?.last || ''}
          </p>
        </div>
      )}

      {containers && containers.length > 0 && (
        <div>
          <p className="label text-xs">Assigned Container(s)</p>
          {containers.map((container, ind) => (
            <div key={ind}>
              <p className="font-semibold underline text-sm">
                {container.friendlyId || `Container ${ind + 1}`}
              </p>
              <p className="label text-sm">
                {container.containerTypeInfo?.name || 'Container type unknown'}
              </p>
            </div>
          ))}
        </div>
      )}

      {truck && (
        <div>
          <p className="label text-xs">Assigned Truck</p>
          <p className="font-semibold underline text-sm">{truck.friendlyId || 'Unknown truck'}</p>
          {truck.size && (
            <p className="label capitalize text-sm">
              {truck.size
                .split('-')
                .join(' ')
                .replace(/-/g, ' ')
                .replace(/\b\w/g, (l) => l.toUpperCase())}
            </p>
          )}
          {truckAddOns && truckAddOns.length > 0 && truckAddOns[0] && (
            <p className="label capitalize">
              {truckAddOns
                .filter(Boolean)
                .join(', ')
                .replace(/-/g, ' ')
                .replace(/\b\w/g, (l) => l.toUpperCase())}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
